import { Typography } from "components/parts/Typography/Typography";
import { newColors } from "constants/newColors";
import styled from "styled-components";

export const StyledMonitorModalInner = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  row-gap: 1rem;
`;

export const StyledTitle = styled(Typography)`
  margin: auto;
  min-height: 1em;
`;

export const StyledErrorMessageWrapper = styled.div`
  border-top: solid 1px ${newColors.border};
  padding: 1em 1em 0 1em;
  box-sizing: border-box;
`;

export const StyledModalMonitorErrorContainer = styled.div`
  background-color: ${newColors.errorZone};
  border: solid 1px ${newColors.errorText};
  border-radius: 5px;
  padding: 1em;
  box-sizing: border-box;

  max-height: 15%;
  overflow-y: auto;
`;
export const StyledModalMonitorWarningContainer = styled(
  StyledModalMonitorErrorContainer
)`
  background-color: ${newColors.warningZone};
  border: solid 1px ${newColors.warningText};
`;

export const StyledModalMonitorErrorMessage = styled.li`
  &:not(:first-child) {
    padding-top: 0.25em;
  }
`;

export const StyledModalInstructionContainer = styled.div`
  display: flex;
  margin-left: 16px;
  gap: 1rem;
`;

export const StyledModalInstruction = styled.div`
  display: flex;
`;

export const StyledColorBox = styled.div<{
  background: React.CSSProperties["background"];
}>`
  background-color: ${({ background }) => background};
  padding: 0.5rem 1rem;
  box-sizing: border-box;
`;

export const StyledModalMonitorTableContainer = styled.div`
  min-height: 150px;
  flex-grow: 1;
`;

export const StyledModalMonitorButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 0.5em;
`;
